'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const ShareAndroidIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.09999 10.98L11.37 9.33998L16.03 7.00998M16.03 16.71L11.37 14.38L8.08999 12.74M8.27999 11.86C8.27999 13.11 7.25999 14.13 6.00999 14.13C4.75999 14.13 3.73999 13.11 3.73999 11.86C3.73999 10.61 4.75999 9.58998 6.00999 9.58998C7.25999 9.58998 8.27999 10.61 8.27999 11.86ZM16.97 3.98998C15.85 4.54998 15.39 5.90998 15.95 7.02998C16.51 8.14998 17.87 8.60998 18.99 8.04998C20.11 7.48998 20.57 6.12998 20.01 5.00998C19.45 3.88998 18.09 3.42998 16.97 3.98998ZM20.01 18.71C20.57 17.59 20.11 16.23 18.99 15.67C17.87 15.11 16.51 15.57 15.95 16.69C15.39 17.81 15.85 19.17 16.97 19.73C18.09 20.29 19.45 19.83 20.01 18.71Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpShareAndroidIcon = forwardRef(ShareAndroidIcon);

export { VpShareAndroidIcon as default };
